import { Reducer } from "redux";

import { WoundCareRecordsResponse } from "../models/Api/Notes";
import { WoundCareDispatchTypes } from "../models/DispatchTypes/Notes";
import { WoundCareActionDispatchTypes } from "../constants/Notes";

export const initialState: WoundCareRecordsResponse = {
  loading: false,
  response: [
    {
      dateCreated: "",
      noteEntryJson: "",
      documentationType: -1,
      orderNumber: -1,
      disciplineName: "",
      serviceNumber: -1,
      fullNameCreated: "",
    },
  ],
};

const WoundCareReducer: Reducer<
    WoundCareRecordsResponse,
    WoundCareDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case WoundCareActionDispatchTypes.WOUND_CARE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case WoundCareActionDispatchTypes.WOUND_CARE_SUCCESS: {
      return {        
        ...state,
        response: action.response,
        loading: false,
      };
    }
  }
  return state;
};

export default WoundCareReducer;
